import React from 'react';
import styled from '@emotion/styled';

type Props = {
  children: React.Node,
};

export const ProgressSteps = ({ children }: Props) => <ProgressWrapper>{children}</ProgressWrapper>;

const ProgressWrapper = styled('div')`
  display: flex;
  width: 100%;
  justify-content: space-evenly;

  @media (${({ theme }) => theme.breakpoint.mobile}) {
    display: block;
    flex-direction: column;
  }
`;
